import { demoFile, component } from 'system/demo';
import { OnlyAdminTeaser } from '../only-admin-teaser';
import { ArticleStructure } from 'structure/article';

demoFile('open-modules/zdf/feature/teaser/only-admin-teaser');

component('OnlyAdminTeaser', OnlyAdminTeaser, {
    structureKey: 'article',
    config: ArticleStructure.receivesConfigDefaults,
    state: { roles: ['Moderator'], collections: { question: [], topic: [] } }
});

